import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <section className="flex min-h-[60vh] items-center justify-center bg-brand-deep px-4 py-24">
      <div className="text-center">
        <p className="font-display text-7xl font-bold text-primary sm:text-8xl">404</p>
        <h1 className="mt-4 text-2xl font-bold text-white sm:text-3xl">Page not found</h1>
        <p className="mx-auto mt-3 max-w-md text-white/70">
          The page you're looking for has moved or doesn't exist. Let's get you back on track.
        </p>
        <Button asChild variant="brand" size="lg" className="mt-8">
          <Link to="/"><HomeIcon className="h-4 w-4" /> Back to home</Link>
        </Button>
      </div>
    </section>
  );
}
